var chunkToChildrenMap = {
	"5385": [
		9724,
		1869,
		3543,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};